import { BerthReservation, BerthReservationOptions } from 'data/models/BerthReservation';
import { ReqChangeId, makePITKey, makePITDataKey } from './PITUtils';

export type BerthReservationPITOptions = ReqChangeId<BerthReservationOptions>;
export const BerthReservationPITKey = makePITKey<BerthReservation>(BerthReservation.key);
export const BerthReservationPITDataKey = makePITDataKey<BerthReservationOptions>(BerthReservation.dataKey);



// WEBPACK FOOTER //
// ./data/models/BerthReservationPIT.ts